import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './EmailThankYou.css';
import { initializeThankYou } from '../thankYouScript.js';

const EmailThankYou = () => {
  useEffect(() => {
    // Add meta tags to head

    const offerMeta = document.createElement('meta');
    offerMeta.name = 'offer';
    offerMeta.content = 'Nomad Notes';
    document.head.appendChild(offerMeta);

    // Initialize call booking
    try {
      initializeThankYou();
    } catch (error) {
      console.error('Error initializing ty script:', error);
    }

    // Cleanup function
    return () => {
      if (document.querySelector('meta[name="offer"]')) {
        document.querySelector('meta[name="offer"]').remove();
      }
    };
  }, []);

  return (
    <div className="email-thank-you-container">
      <div className="thank-you-content">
        <div className="success-icon">
          📧 ✅
        </div>
        <h1>Subscription Confirmed!</h1>
        <p>Thank you for subscribing to our newsletter. You'll receive updates on expat opportunities, tax optimization strategies, and relocation insights.</p>
        
        <div className="confirmation-reminder">
          <h3>📬 Important: Check Your Email!</h3>
          <p>Please check your inbox for a confirmation email and click the link to complete your subscription. Don't forget to check your spam folder if you don't see it within a few minutes.</p>
        </div>

        <div className="next-steps">
          <h3>What's Next?</h3>
          <ul>
            <li>Check your email for a welcome message</li>
            <li>Add us to your contacts to ensure delivery</li>
            <li>You'll receive weekly insights on expat opportunities</li>
            <li>Get exclusive access to relocation guides and resources</li>
          </ul>
        </div>

        <div className="additional-resources">
          <h3>Explore Our Services</h3>
          <p>Looking to relocate, get a new citizenship or company setup? Check out our partnered services:</p>
          <div className="resource-links">
            <Link to="/relocation-services" className="resource-link">
              View All Services
            </Link>
            <Link to="/uae" className="resource-link">
              UAE Setup Guide
            </Link>
            <Link to="/mexico-residency" className="resource-link">
              Mexico Residency
            </Link>
            <Link to="/consultation" className="resource-link">
              Book a Consultation
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmailThankYou;
